var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoScheduleInspection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "26px",
    viewBox: "0 0 36 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-926.000000, -1136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(926.000000, 1136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(28.500000, 13.000000) scale(-1, 1) translate(-28.500000, -13.000000) translate(21.500000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6491601,25 L12.2880442,4 C8.73475913,4 8.24346947,4 2,4 C1.44771525,4 1,4.44771525 1,5 L1,24 C1,24.5522847 1.44771525,25 2,25 C8.55328775,25 9.08295552,25 12.6491601,25 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 0,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5,
    y: 0,
    width: 2,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 11.5,
    y: 0,
    width: 2,
    height: 7,
    rx: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 1,
    y: 3,
    width: 17,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 6,
    y: 1.5,
    width: 6,
    height: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-99-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "6.5 13.5009766 9.5 16.5009766 14.8417969 11.1591797"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoScheduleInspection);
export default __webpack_public_path__ + "static/media/ico_schedule-inspection.e5247c5341cebad0659e340eb900c981.svg";
export { ForwardRef as ReactComponent };